<div
  class="img-departure-return {{ size }}"
  [ngStyle]="{
    'background-image':
      buttonDisplayType === 'button-active'
        ? isDesktopSig()
          ? 'url(' + buttonImageDesktop + ')'
          : 'url(' + buttonImage + ')'
        : 'none'
  }"
>
  <div class="inner-card" [ngClass]="{ 'from-date': dateType === ButtonDateType.Departure }">
    @if (showButtonImageAirplane) {
      <img
        class="airplane-img"
        [alt]="dateType === ButtonDateType.Departure ? departureAltText : returnAltText"
        [src]="isDesktopSig() ? buttonImageAirplaneDesktop : buttonImageAirplane"
      />
    }

    <div class="card-description headline5-main-title">
      <span>{{ activeImageText }}</span>
    </div>
  </div>
</div>
<div class="completed-detail {{ size }}" attr.data-testid="completed-detail-{{ dateType }}">
  <pc-departure-return-detail
    [businessUnit]="businessUnit"
    [dateType]="dateType"
    [departureAltText]="departureAltText"
    [details]="dateDetail"
    [editButtonDescription]="dateEditDescription"
    [editButtonText]="dateEditText"
    [isLTR]="isLTR"
    [returnAltText]="returnAltText"
    [showButtonImageAirplane]="showButtonImageAirplane"
    [size]="size"
    (editDates)="editSelectedDates($event)"
  >
  </pc-departure-return-detail>
</div>
